function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.11454 6.55229C3.61445 6.05219 3.3335 5.37391 3.3335 4.66667C3.3335 3.95942 3.61445 3.28115 4.11454 2.78105C4.61464 2.28095 5.29292 2 6.00016 2C6.70741 2 7.38568 2.28095 7.88578 2.78105C8.38588 3.28115 8.66683 3.95942 8.66683 4.66667C8.66683 5.37391 8.38588 6.05219 7.88578 6.55229C7.38568 7.05238 6.70741 7.33333 6.00016 7.33333C5.29292 7.33333 4.61464 7.05238 4.11454 6.55229Z",
  stroke: "currentColor",
  strokeWidth: 1.3333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14",
  stroke: "currentColor",
  strokeWidth: 1.3333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6665 4.6665C11.1969 4.6665 11.7056 4.87722 12.0807 5.25229C12.4558 5.62736 12.6665 6.13607 12.6665 6.6665C12.6665 6.13607 12.8772 5.62736 13.2523 5.25229C13.6274 4.87722 14.1361 4.6665 14.6665 4.6665C14.1361 4.6665 13.6274 4.45579 13.2523 4.08072C12.8772 3.70564 12.6665 3.19694 12.6665 2.6665C12.6665 3.19694 12.4558 3.70564 12.0807 4.08072C11.7056 4.45579 11.1969 4.6665 10.6665 4.6665Z",
  stroke: "currentColor",
  strokeWidth: 1.3333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMapperSuggestions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapperSuggestions);
export default __webpack_public_path__ + "static/media/mapper-suggestions.d5261360.svg";
export { ForwardRef as ReactComponent };